module.exports = __webpack_public_path__ + "img/image.d9ef0dd5.svg";